import { combineReducers } from 'redux';
import searchResultReducer from './search-result';

const settingsServiceStatusReducer = combineReducers({
  searchResult: searchResultReducer,
});

export default settingsServiceStatusReducer;
